/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_managing_business_and_tech_is_impossible = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gérer votre business ET développer vos solutions tech, c'est mission impossible.`)
};

const en_managing_business_and_tech_is_impossible = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Managing your business and building your tech solutions at the same time feels impossible.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const managing_business_and_tech_is_impossible = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.managing_business_and_tech_is_impossible(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("managing_business_and_tech_is_impossible", locale)
	if (locale === "fr") return fr_managing_business_and_tech_is_impossible(inputs)
	return en_managing_business_and_tech_is_impossible(inputs)
};